import Item from "../../../core/items/Item"
import Deadge from "../../../core/assets/oot/classic/deadge.png"
import { OotItemDto } from "../../hints/OotItemAutocomplete"
import { SimpleItemProps } from "./SimpleItemProps"
import StaticItem from "../../../core/items/StaticItem"



export const DefaultDeadgeItem : OotItemDto = {
    img: Deadge,
    name: "Deadge",
}
export const DeadgeItem = () => {


    return <Item
        image={Deadge}
        isObtained={true}
        id={"Deadge"}
        onClick={() => { }}
        title="Deadge"
    />


}


export const SimpleDeadgeItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={Deadge}
        onClick={props.onClick}
        name={"Deadge"}
    />



}